import React from "react";
import ImageScroll from "../ImageScroll/ImageScroll.js";
import washing10 from "../image/Bloom1.jpg";
// import washing15 from "../image/Banner 15.jpg";
// tv banner
const Banner2 = () => {
  return (
    
    <div>
      <ImageScroll>
    <div className="relative ">
      <img className="w-full h-full" src={washing10} alt="" />
      {/* <img className="w-full h-full" src={washing15} alt="" /> */}
    </div>
    </ImageScroll>
    </div>
  );
};


export default Banner2;

